<template>
    <el-dialog title="代理信息维护" :visible="visible" :show="show" width="50%" :close-on-click-modal="false"
               @close="close" custom-class="org-dialog">
        <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">
            <el-form-item label="上级组织名称" class="input" prop="orgSupName" >
                <el-input v-model="ruleForm.orgSupName" autocomplete="off" readonly></el-input>
            </el-form-item>
            <el-form-item label="组织名称" class="input" prop="orgName" >
                <el-input v-model="ruleForm.orgName" autocomplete="off" placeholder="请输入组织名称"></el-input>
            </el-form-item>
            <el-form-item label="组织类型" class="input" prop="orgType" >
                <el-input v-model="orgTypeName" readonly></el-input>
            </el-form-item>
            <el-form-item label="组织描述" class="input" prop="orgDesc" >
                <el-input type="textarea" v-model="ruleForm.orgDesc" autocomplete="off" :rows="4" placeholder="请输入组织描述"></el-input>
            </el-form-item>

            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;gap: 12px;padding-top: 10px;">
                <el-button class="btn" type="primary" v-show="updateBtn" @click="commit()">保存</el-button>
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>
<script>
    import base from '../../../utils/base'
    export default{
        name:'addOrUpdate',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                    this.initOrgTypeList();
                }
            },
            rowData(){
                if(this.rowData.type=='edit'){
                    this.ruleForm = this.rowData;
                    this.orgTypeName = this.rowData.orgType == '2' ? '城市' : this.rowData.orgType == '3' ? '到场地' : '';
                }else{
                    this.ruleForm.orgSupId = this.rowData.orgId;
                    this.ruleForm.orgSupName = this.rowData.orgName;
                    this.ruleForm.orgPathname = this.rowData.orgPathname;
                    this.ruleForm.path = this.rowData.path;
                    this.ruleForm.code = this.rowData.code;
                    this.ruleForm.orgType = this.rowData.orgType;
                    this.ruleForm.orgId = null;
                    this.orgTypeName = this.rowData.orgType == '2' ? '城市' : this.rowData.orgType == '3' ? '到场地' : '';
                }
            },
        },
        data(){
            return{
                updateBtn:true,
                url:base.get().url,
                visible:false,
                orgTypeName:'',
                ruleForm:{
                    title:'',
                    context:'',
                    isShow:'',
                },
                rules:{
                    orgName:[{ required: true, message: '请输入组织名称', trigger: 'blur' }],
                    orgType:[{ required: true, message: '请选择组织类型', trigger: 'blur' }],
                    orgCode:[{ required: true, message: '请输入组织代码', trigger: 'blur' }],
                },
                orgTypeList:[],
            }
        },
        methods:{
            close(){
                this.updateBtn = true;
                this.$refs['ruleForm'].resetFields();
                this.$emit("listenToChildEvent",false);
            },
            commit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.$http({
                            url:  this.ruleForm.orgId==''|| this.ruleForm.orgId==undefined?this.url+`sysOrg/`+"save":this.url+`sysOrg/`+"update",
                            method: "post",
                            data:this.ruleForm
                        }).then(({ data }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: "保存成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.close();
                                    }
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                });
            },
            initOrgTypeList(){
                let params = {
                    page: this.pageIndex,
                    limit: this.pageSize,
                    sort: 'id',
                }
                //本表的
                params['dicCode'] = "org_types"//编码名字
                params['dicName'] = "组织类型",//汉字名字
                this.$http({
                    url: "dictionary/page",
                    method: "get",
                    params: params
                }).then(({ data }) => {
                    if (data && data.code === 0) {
                        this.orgTypeList = data.data.list;
                    }
                });
            },
        }
    }
</script>
<style lang="scss">
    .org-dialog .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
    }

    .org-dialog .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }

    .org-dialog .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
    }

    .org-dialog .el-dialog__body {
        padding: 24px 32px 16px;
    }

    .detail-form-content .el-form-item__label {
        font-weight: 600;
        color: #303133;
    }

    .detail-form-content .el-input.is-disabled .el-input__inner {
        background-color: #f5f7fa;
        color: #909399;
        cursor: not-allowed;
    }

    .detail-form-content .btn {
        min-width: 100px;
    }

    .detail-form-content .close {
        color: #606266;
        border-color: #dcdfe6;
    }

    .detail-form-content .close:hover {
        color: var(--publicMainColor);
        border-color: rgba(58, 110, 165, 0.3);
        background-color: rgba(58, 110, 165, 0.08);
    }
</style>